import { BKPR_PREFIX } from '../constants';

export const isBkprUrl = (url: string) => {
    return url.includes(`${BKPR_PREFIX}/`);
};
